//⚙️ API Intigration page

export default function SellersPage() {
  return (
    <div className="p-8">
      <div className="text-2xl font-bold">⚙️ API Intigration</div>
      <div className="mt-3 text-gray-600">
        (Placeholder) — This page under working
      </div>
      <div className="mt-6 p-6 rounded-xl border border-black/10 bg-white">
        Create API for social media page
      </div>
    </div>
  );
}
